// theme.js — brutalist palette
// kept for any styled-components still consuming the theme prop.

export const brutalistTheme = {
  body: "#f0eee5",
  paper: "#f8f5ea",
  text: "#0c0c0c",
  textSoft: "#222",
  muted: "#6a6a64",
  highlight: "#ff5500",
  accent: "#ff5500",
  accent2: "#dde64a",
  dark: "#0c0c0c",
  hair: "rgba(12,12,12,0.1)",
  hairStrong: "rgba(12,12,12,0.2)",

  // legacy keys
  secondaryText: "#6a6a64",
  imageHighlight: "#ff5500",
  compImgHighlight: "rgba(12,12,12,0.05)",
  jacketColor: "#0c0c0c",
  headerColor: "#f0eee5",
};

export const chosenTheme = brutalistTheme;
